$('.slider__list').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  arrows: false,
  centerMode: false,
  speed: 750,
});
